import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FooterProps } from '../components/Footer/components/Footer';
import { HeaderWrapperProps } from '../components/Header/components/HeaderWrapper';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import type { ProgressBarProps } from '../components/ProgressBar';

type RenterInsuranceLayoutFooterProps = Omit<FooterProps, 'withBackgroundColor'>;

type Props = {
  children: React.ReactNode;
  headerProps?: HeaderWrapperProps;
  footerProps?: RenterInsuranceLayoutFooterProps;
  withHeader?: boolean;
  withFooter?: boolean;
  progressBarProps?: ProgressBarProps
}

const defaultFooterProps: RenterInsuranceLayoutFooterProps = {
  withMarginTop: false,
  complianceFlowFooter: false,
}

function RentersInsuranceLayout({
  children,
  headerProps = {},
  progressBarProps = {},
  withHeader = true,
  withFooter = true,
  footerProps = defaultFooterProps,
}: Props) {
  return (
    <>
      {progressBarProps.progress && <ProgressBar {...progressBarProps} />}
      {withHeader && <Header {...headerProps} />}
      {children}
      {withFooter && <Footer {...footerProps} withBackgroundColor={false}/>}
    </>
  );
}

export default RentersInsuranceLayout;
